/* eslint-disable */
// 百度地图获取当前定位
export function getPosition() {
    let geolocation = new BMap.Geolocation();
    return new Promise((resolve, reject) => {
        geolocation.getCurrentPosition(
            function(r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    var geoc = new BMap.Geocoder();
                    geoc.getLocation(r.point, function(rs) {
                        /**
                         * @param streetNumber	String	门牌号码
                         * @param street	String	街道名称
                         * @param district	String	区县名称
                         * @param city	String	城市名称
                         * @param province	String	省份名称
                         */
                        // 成功之后将返回值返回resolve
                        resolve({ point: r.point, address: rs.addressComponents });
                    });
                } else {
                    //错误之后将状态码返回给catch
                    reject(this.getStatus());
                }
            }, { enableHighAccuracy: true }
        );
    });

}
// 百度地图
/**
 * @export
 * @param {any} nodeId dom节点
 * @param {any} latitude 经度
 * @param {any} longitude 纬度
 * @returns
 */
export function getMap(nodeId, latitude, longitude) {
    return new Promise(function(resolve, reject) {
        var map = new BMap.Map(nodeId); // 创建Map实例
        var point = new BMap.Point(latitude, longitude);
        map.centerAndZoom(point, 15);
        var marker = new BMap.Marker(point); // 创建标注
        map.addOverlay(marker);
    })
}

//路线规划
export function getDrivingRoute(nodeId,slat, slon, dlat, dlon) {
  return new Promise(function(resolve, reject) {
    var map = new BMap.Map(nodeId); // 创建Map实例
    var point1 = new BMap.Point(slon,slat);
    var point2 = new BMap.Point(dlon,dlat);
    map.centerAndZoom(point1, 11);
    var driving = new BMap.DrivingRoute(map, {renderOptions:{map: map, autoViewport: true}});
    driving.search(point1, point2);
  })
}

//验证身份证
export function checkID(ID) {
    let regExp = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/i;
    return regExp.test(ID) ? true : false;
}
//根据身份证号判别男女
export function discriCard(UUserCard){
  if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
    return '男'
  } else {
    return '女'
  }
}
// 校验手机号
export function checkPhone(number) {
    let regExp = /^1\d{10}$/;
    return regExp.test(number) ? true : false;
}

// 校验密码强度
export function checkPwd(pwd) {
    let regExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
    return regExp.test(pwd) ? true : false;
}

export function checkEmail(email) {
  let regExp = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
  return regExp.test(email) ? true : false;
}

//隐藏手机号关键信息
export function phone(mobilePhone) {
  return mobilePhone.replace(/(\d{3})(\d{4})(\d{4})/,"$1****$3")
}
//隐藏身份证关键信息
export function identity(identity) {
  return identity.replace(/(\d{4})\d{10}(\d{3})/,"$1****$2")
}
export function refreshPage() {
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none'
        // 替换成站标favicon路径或者任意存在的较小的图片即可
    iframe.setAttribute('src', '/favicon.ico')
    var iframeCallback = function() {
        setTimeout(function() {
            iframe.removeEventListener('load', iframeCallback)
            document.body.removeChild(iframe)
        }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
}

/* cookie的存取 start */
import Cookies from 'js-cookie'

export function setCookie(name, value) {
    return Cookies.set(name, value)
}
export function getCookie(name) {
    return Cookies.get(name)
}
export function delCookie(name) {
    return Cookies.remove(name)

}
/* cookie的存取 end */

/* 手机机型和环境判断 start */
export function isWechat() {
    let ua = window.navigator.userAgent.toLowerCase()
    return ua.match(/MicroMessenger/i) == 'micromessenger' ? true : false
}
export function isAlipay() {
    let ua = window.navigator.userAgent.toLowerCase()
    return ua.match(/AlipayClient/i) == 'alipayclient' ? true : false
}
export function isAndroid() {
    let ua = window.navigator.userAgent.toLowerCase()
    return ua.indexOf('android') > -1 ? true : false
}
export function isiOS() {
    let ua = window.navigator.userAgent
    return ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? true : false
}
/* 手机机型和环境判断 end */
/* 获取url上的参数 start */
export function GetUrlParam() {
  var name, value;
  var str = location.href; //取得整个地址栏
  var num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

  var arr = str.split("&"); //各个参数放到数组里
  for (var i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substring(0, num);
      value = arr[i].substr(num + 1);
      this[name] = value;
    }
  }
}
/* 获取url上的参数 end */

/**
 * 格式化时间
 * @param {any} time
 * 时间对象或字符串
 * @param {string} cFormat
 * 自定义日期格式y|m|d|h|i|s|a对应年月日时分秒星期
 * 例如'{m}/{d} {h}/{i}' 默认 '{y}-{m}-{d} {h}:{i}:{s}'
 * @return {string}
 * 格式化后的时间
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  // 时间对象 直接赋值
  if (typeof time === 'object') {
    date = time
  } else {
    // 10位时间戳也就是单位为s的时间戳 转13位 ms
    if (('' + time).length === 10) time = parseInt(time) * 1000
    // 转时间对象
    date = new Date(time)
  }
  // 获取年月日时分秒星期
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    // 遍历格式 替换成具体的时间
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    // 补零
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
/* 获取指定url上的参数 start */
export function GetAssignUrlParam(url) {
  var name, value;
  var str = url; //取得整个地址栏
  var num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

  var arr = str.split("&"); //各个参数放到数组里
  for (var i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substring(0, num);
      value = arr[i].substr(num + 1);
      this[name] = value;
    }
  }
}
/* 获取指定url上的参数 end */



// WEBPACK FOOTER //
// ./src/utils/tools.js